var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var formatAnswerPayload = function (userAnswers) {
    var allowedCharsRegex = /[^0-9a-zA-Z~!@#$%^&*_+=?\t\n\r\b\f'"`{}[\]:;,.()\\[ -/|]/g;
    var diacriticsUnicodesRegex = /[\u0300-\u036f]/g;
    return userAnswers.map(function (_a) {
        var nextQuestionId = _a.nextQuestionId, disputeReason = _a.disputeReason, script = _a.script, isEligibleForPartialAmount = _a.isEligibleForPartialAmount, formattedUserAnswer = __rest(_a, ["nextQuestionId", "disputeReason", "script", "isEligibleForPartialAmount"]);
        var questionText = formattedUserAnswer.questionText;
        var id = formattedUserAnswer.id;
        var answers = formattedUserAnswer.answers.map(function (item, index) {
            var noSpecialCharsText = item
                /*
                 * Each character is represented by a unicode, Letters containing diacritics can be represented by two.
                 * NFD returns the decomposed version, meaning that (i.e.) ñ will be split into \u006E\u0303 unicode. Then we remove them.
                 */
                .normalize('NFD')
                .replace(diacriticsUnicodesRegex, '')
                .replace(allowedCharsRegex, '');
            if (index === 0) {
                return { id: formattedUserAnswer.answerId, text: noSpecialCharsText };
            }
            return {
                id: '',
                text: noSpecialCharsText
            };
        });
        return { answers: answers, questionText: questionText, id: id };
    });
};
export default formatAnswerPayload;
//# sourceMappingURL=formatAnswerPayload.js.map